export const NAVBAR_HEIGHT = 64; // px
export const NAVBAR_Z_INDEX = 1100;
export const MOBILE_DRAWER_WIDTH = 380; // px
